import { useAndroidBackButton } from '@/hooks/useAndroidBackButton';

/**
 * Component that handles Android back button navigation.
 * Must be rendered inside BrowserRouter context.
 * Renders nothing - just provides back button behavior.
 */
const AndroidBackHandler = () => {
  useAndroidBackButton();
  return null;
};

export default AndroidBackHandler;
